import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_NEW_FIELD_BEGIN,
  COLLECTIONS_CREATE_NEW_FIELD_SUCCESS,
  COLLECTIONS_CREATE_NEW_FIELD_FAILURE,
  COLLECTIONS_CREATE_NEW_FIELD_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createNewField(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_NEW_FIELD_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionName}/fields`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_CREATE_NEW_FIELD_SUCCESS,
              data: res.data,
              collectionName,
            });
            Mixpanel.track('Created Collection Field');
            toast.success('Created Field Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_CREATE_NEW_FIELD_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create collection field');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_NEW_FIELD_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create collection field');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateNewFieldError() {
  return {
    type: COLLECTIONS_CREATE_NEW_FIELD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_NEW_FIELD_BEGIN:
      return {
        ...state,
        createNewFieldPending: true,
        createNewFieldError: null,
      };

    case COLLECTIONS_CREATE_NEW_FIELD_SUCCESS:
      let currentFields = state.selectedCollection.fields || [];
      currentFields = action.data.fields;
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.collectionName === action.collectionName;
      });
      projectCollections[index].fields = currentFields;
      return {
        ...state,
        createNewFieldPending: false,
        createNewFieldError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          fields: currentFields,
        },
      };

    case COLLECTIONS_CREATE_NEW_FIELD_FAILURE:
      return {
        ...state,
        createNewFieldPending: false,
        createNewFieldError: action.data.error,
      };

    case COLLECTIONS_CREATE_NEW_FIELD_DISMISS_ERROR:
      return {
        ...state,
        createNewFieldError: null,
      };

    default:
      return state;
  }
}
